import React from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import { Tooltip } from '@ui/atoms/Tooltip';
import { getDateFormat } from '../../../utils/getDatetimeFormat';
import { Loader, LoaderSizes } from '../../../components/Loader/Loader';
import { ReviewStatus } from '../types';
import { StatusAllowedDefDetails } from '../constants';
const namespace = 'features.documents';
function getDocumentColumns({ onRequestDelete, onOpenDeficiencies, onRequestScan, onToggleShowOnReport, idLoading, canDelete, aiEnabled, isPrime, onToggleSelect, selectedIds, canPublish }) {
    const baseColumns = [
        {
            label: translate('document', { namespace }),
            dataKey: 'name',
            width: 240,
            renderer: ({ item }) => {
                return (React.createElement("div", { className: "doc-name-container" },
                    item.type === 'Image' && React.createElement("i", { className: "fa-light fa-file-image" }),
                    item.type === 'Document' && React.createElement("i", { className: "fa-light fa-file-word" }),
                    React.createElement("a", { rel: "noreferrer", className: "qmb-link", href: item.url, target: "_blank" }, item.file_name)));
            }
        },
        {
            label: translate('document_type', { namespace }),
            align: 'left',
            dataKey: 'content_type',
            width: 416
        },
        {
            label: translate('uploaded', { namespace }),
            align: 'left',
            dataKey: 'createdAt',
            width: 416,
            renderer: ({ item }) => {
                const scheduledDate = new Date(item === null || item === void 0 ? void 0 : item.created_at);
                if (!Number.isNaN(scheduledDate.getTime())) {
                    return getDateFormat(item === null || item === void 0 ? void 0 : item.created_at);
                }
                return React.createElement("span", null, translate('n_a', { namespace: 'features.commons' }));
            }
        },
        aiEnabled &&
            isPrime && {
            label: translate('review_status', { namespace }),
            align: 'left',
            dataKey: 'status',
            renderer: ({ item }) => {
                return React.createElement("span", null, item.status && item.canAi ? translate(item.status, { namespace }) : '--');
            },
            width: 150
        },
        {
            label: '',
            align: 'left',
            dataKey: 'id',
            renderer: ({ item }) => {
                const showToggleShowOnReport = isPrime && item.pdf && !!onToggleShowOnReport;
                const subDeleteBlocked = !isPrime && item.show_on_report;
                const buttons = [
                    aiEnabled &&
                        item.canAi &&
                        isPrime &&
                        (item.status === ReviewStatus.Unscanned || item.status === ReviewStatus.Scanning) && (React.createElement("button", { type: "button", "aria-label": "Scan document", className: "qmb-control--icon", disabled: item.status === ReviewStatus.Scanning, "data-title": item.status === ReviewStatus.Scanning ? translate('processing', { namespace }) : undefined, onClick: () => {
                            void (onRequestScan === null || onRequestScan === void 0 ? void 0 : onRequestScan(item.id));
                        } },
                        React.createElement("i", { className: "fa-light fa-sparkles" }))),
                    aiEnabled && isPrime && item.canAi && item.status && StatusAllowedDefDetails.includes(item.status) && (React.createElement("button", { type: "button", "aria-label": "Open Deficiencies", className: "qmb-control--icon", onClick: () => {
                            onOpenDeficiencies === null || onOpenDeficiencies === void 0 ? void 0 : onOpenDeficiencies(item);
                        } },
                        React.createElement("i", { className: "fa-light fa-file-magnifying-glass" }))),
                    showToggleShowOnReport && (React.createElement(Tooltip, { content: translate(item.show_on_report ? 'show_on_report.hide' : 'show_on_report.show', { namespace }) },
                        React.createElement(Button, { variant: item.show_on_report ? 'highlighted' : 'default', "aria-label": translate(item.show_on_report ? 'show_on_report.hide' : 'show_on_report.show', { namespace }), "aria-pressed": item.show_on_report, onClick: () => {
                                onToggleShowOnReport === null || onToggleShowOnReport === void 0 ? void 0 : onToggleShowOnReport(item.id, !item.show_on_report);
                            } },
                            React.createElement("i", { className: `fa-light ${item.show_on_report ? 'fa-eye' : 'fa-eye-slash'}` })))),
                    canDelete && idLoading !== item.id && (aiEnabled || !item.canAi) && !subDeleteBlocked && (React.createElement("button", { type: "button", "aria-label": "Delete", className: "qmb-control--icon", onClick: () => {
                            onRequestDelete === null || onRequestDelete === void 0 ? void 0 : onRequestDelete(item.id);
                        } },
                        React.createElement("i", { className: "fa-light fa-trash-can" }))),
                    canDelete && idLoading !== item.id && (aiEnabled || !item.canAi) && subDeleteBlocked && (React.createElement(Tooltip, { content: translate('show_on_report.delete_blocked_tooltip', { namespace }), multiline: true },
                        React.createElement("button", { type: "button", "aria-label": "Delete", "aria-disabled": "true", disabled: true, className: "qmb-control--icon", onClick: (e) => {
                                e.preventDefault();
                            } },
                            React.createElement("i", { className: "fa-light fa-trash-can" })))),
                    idLoading === item.id && React.createElement(Loader, { size: LoaderSizes.small })
                ].filter(Boolean);
                return React.createElement("div", { className: "buttonContainer" }, ...buttons);
            }
        }
    ].filter(Boolean);
    if (canPublish && onToggleSelect && selectedIds) {
        const selectColumn = {
            label: '',
            dataKey: 'select',
            width: 60,
            renderer: ({ item }) => (React.createElement("input", { type: "checkbox", checked: selectedIds.includes(item.id), onChange: (e) => {
                    onToggleSelect(item.id, e.target.checked);
                } }))
        };
        baseColumns.unshift(selectColumn);
    }
    return baseColumns;
}
export default getDocumentColumns;
